// The legal pages, each at its own public path (`/privacy`, …), in the order they're linked (plan task 57).
export const LEGAL_DOCUMENTS = ['privacy', 'imprint', 'terms', 'dpa'] as const;
export type LegalDocument = (typeof LEGAL_DOCUMENTS)[number];

// The date the texts were last changed. A change of the terms or the AVV also changes TERMS_VERSION in
// api/workspaces/models.py, which is what a new workspace's owner accepts.
export const LEGAL_TEXTS_DATE = '2026-10-13';

// Until a lawyer has reviewed the texts, the pages say they're a draft (plan task 57's Open).
export const IS_LEGAL_DRAFT = false;
